export const CALENDAR_STATUS_MAP = {
    PLANIFIE: {
        value: "PLANIFIE",
        label: "Planifié",
        color: "#1f7a8c",
        background: "#d7f2f8",
        borderColor: "#6ac8db",
    },
    EN_COURS: {
        value: "EN_COURS",
        label: "En cours",
        color: "#455584",
        background: "#f9fefd",
        borderColor: "#a3b0d2",
    },
    ANNULE: {
        value: "ANNULE",
        label: "Annulé",
        color: "#b42318",
        background: "#fee4e2",
        borderColor: "#334785",
    },
    "ANNULÉ": {
        value: "ANNULÉ",
        label: "Annulé",
        color: "#b42318",
        background: "#fee4e2",
        borderColor: "#334785",
    },
    TERMINE: {
        value: "TERMINE",
        label: "Terminé",
        color: "#475467",
        background: "#eaecf0",
        borderColor: "#98a2b3",
    },
    CLOTURE: {
        value: "CLOTURE",
        label: "Cloturé",
        color: "#475467",
        background: "#eaecf0",
        borderColor: "#98a2b3",
    },
    DEFAULT: {
        value: "DEFAULT",
        label: "Autre",
        color: "#344054",
        background: "#f2f4f7",
        borderColor: "#d0d5dd",
    },
};

export const CALENDAR_STATUS_ORDER = ["PLANIFIE", "EN_COURS", "ANNULE", "TERMINE", "CLOTURE"];

export const toCalendarStatusValue = (status) => {
    const value = String(status || "").trim().normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();
    if (value === "ANNULE") return "ANNULE";
    return value;
};

export const getCalendarStatusMeta = (status) => {
    if (!status) return CALENDAR_STATUS_MAP.DEFAULT;
    return CALENDAR_STATUS_MAP[toCalendarStatusValue(status)] || CALENDAR_STATUS_MAP.DEFAULT;
};

export const getAvailableCalendarStatuses = (events = []) => {
    const unique = new Set(events.map((event) => toCalendarStatusValue(event?.status)).filter(Boolean));
    const ordered = CALENDAR_STATUS_ORDER
        .filter((status) => unique.size ? unique.has(status) || CALENDAR_STATUS_ORDER.includes(status) : true)
        .map((status) => getCalendarStatusMeta(status));

    unique.forEach((status) => {
        if (!CALENDAR_STATUS_ORDER.includes(status)) {
            ordered.push(getCalendarStatusMeta(status));
        }
    });

    return ordered.filter((status, index, array) => array.findIndex((item) => item.value === status.value) === index);
};
